<template>
  <svg width="14" height="4" viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.00141 0.689941C6.28141 0.689941 5.69141 1.27994 5.69141 1.99994C5.69141 2.71994
      6.28141 3.30994 7.00141 3.30994C7.72141 3.30994 8.31141 2.71994 8.31141 1.99994C8.31141
      1.27994 7.72141 0.689941 7.00141 0.689941Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
    />
    <path
      d="M2.00141 0.689941C1.28141 0.689941 0.691406 1.27994 0.691406 1.99994C0.691406 2.71994
      1.28141 3.30994 2.00141 3.30994C2.72141 3.30994 3.31141 2.71994 3.31141 1.99994C3.31141
      1.27994 2.72141 0.689941 2.00141 0.689941Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
    />
    <path
      d="M12.0014 0.689941C11.2814 0.689941 10.6914 1.27994 10.6914 1.99994C10.6914 2.71994
      11.2814 3.30994 12.0014 3.30994C12.7214 3.30994 13.3114 2.71994 13.3114 1.99994C13.3114
      1.27994 12.7214 0.689941 12.0014 0.689941Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true;"
      @mouseout="isHover = false;"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    color: {
      type: String,
    },
  },
};
</script>
